<template>
  <main>
    <app-header />
    <router-view class="main" />
  </main>
</template>

<script>
  import app from '@/mixins/app';
  import { setToken } from '@/lib/token';

  const consumeToken = () => {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    const token = params.get('token');
    if (token) {
      setToken(token, true);
      const urlWithoutQueryString = `${url.origin}${url.pathname}`;
      window.history.replaceState({}, null, urlWithoutQueryString);
    }
  };

  export default {
    name: 'AdminIndex',
    components: {
      'app-header': () => import('@/views/admin/components/app-header.vue'),
    },
    mixins: [app],
    mounted() {
      consumeToken();
    },
  };
</script>

<style lang="stylus" scoped>
  .main
    height: calc(100vh - 60px)
    width: calc(100% - 60px)
    margin: 0 auto
    margin-top: 45px
</style>

<style lang="stylus">
  .list
    margin-top: 20px

  .info
    display: flex

    span:first-child
      font-weight: bold

    span:not(:first-child)
      margin-left: 5px

  .info:not(:first-child)
    margin-top: 20px
</style>
